import store from "@/store";

export const checkCascadingDispatchRequestsHaveNoOtherStatuses = (dispatchRequestToTest, allDispatchRequests, statuses) => {
    let cascadedDispatchRequests = [
        ...dispatchRequestToTest.cascades_into_dispatch_requests ?? [],
        ...dispatchRequestToTest.cascades_from_dispatch_requests ?? [],
    ]

    statuses = [
        undefined, // Undefined should always be an option, in case the cascaded DRQ is not in allDispatchRequests
        ...statuses,
    ]

    return !cascadedDispatchRequests.filter(cdr => {
        return !statuses.includes(allDispatchRequests.find(cdr2 => cdr2.id === cdr.id)?.status)
    }).length
}

/**
 * Deze functie is het frontend equivalent van \App\Models\Omt\DispatchRequest::getIsPickupableAttribute(). Dus als die wijzigt moet deze ook wijzigen!
 */
export const checkDispatchRequestIsPickupableWithCode = async (dispatchRequest) => {
    if (dispatchRequest.is_replaced || dispatchRequest.status !== 'ready-to-ship' || dispatchRequest.dispatch_type.identifier !== 'click_and_collect' || dispatchRequest.paused_at) {
        return false
    }

    await store.getters.getAllLocations
    return !!store.state.allLocations
        .find(location => location.identifier === dispatchRequest.dispatcher_identifier)
        ?.location_properties
        ?.['orderPickupWithCodeEnabled']
}
